<div class="container-fluid">
  <div class="row top10 no-gutters">
    <div class="col-xs-12 col-md-6 vcenter">
      <h3>My Current Travel Requests</h3>
    </div>
    <div class="col-xs-12 col-md-6  vcenter-right">
    </div>
  </div>
  <hr style="margin-top:2px;margin-bottom:2px" />

  <div class="row top10">
    <div class="col-xs-12">
      <aims-common-table
        id="trvl-dashboard-table"
        [dataSource]="myCurrTravelRequests | async"
        [header]="tableHeader"
        [permissions]="tablePermissions | async"
        [pageSize]="15"
        [stickyHeader]="true">
      </aims-common-table>
    </div>
  </div>

</div>
